import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/swiper-bundle.min.js'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'

var swiper1 = new Swiper(".download-pro-article .cont2 .mySwiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoHeight: true,
  allowTouchMove: false,
  on:{
    init: function(swiper){
      $('.download-pro-article .cont2 .swiper-tab>div').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.download-pro-article .cont2 .swiper-tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})

$('.download-pro-article .cont2 .swiper-tab>div').on('click',function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let scrollT = $('.download-pro-article .cont2').offset().top - $('.download-header').height()

  if (scroH > scrollT) {
    $('.download-pro-article .cont2 .fixed-tab').addClass('fixed')
  }else{
    $('.download-pro-article .cont2 .fixed-tab').removeClass('fixed')
  }

});